import request from "../Config/axios";

//------------------------------------------------------------
// همه رکوردها
export const GetAll_ObjectOutOfService_Api = async () => {
    const { data } = await request.get(
        "/ObjectOutOfServices/GetAll"
    );
    return data;
};

//------------------------------------------------------------
// بر اساس شناسه
export const GetById_ObjectOutOfService_Api = async (id) => {
    const { data } = await request.get(
        `/ObjectOutOfServices/GetById?id=${id}`
    );
    return data;
};

//------------------------------------------------------------
// رکوردهای یک آبجکت
export const GetByObjectInstance_ObjectOutOfService_Api = async (objectInstanceId) => {
    const { data } = await request.get(
        `/ObjectOutOfServices/GetByObjectInstance?objectInstanceId=${objectInstanceId}`
    );
    return data;
};

//------------------------------------------------------------
// بررسی در دسترس بودن
export const CheckAvailability_ObjectOutOfService_Api = async (params) => {
    const { data } = await request.post(
        "/ObjectOutOfServices/CheckAvailability",
        params
    );
    return data;
};

//------------------------------------------------------------
// افزودن
export const Add_ObjectOutOfService_Api = async (params) => {
    const { data } = await request.post(
        "/ObjectOutOfServices/Add",
        params
    );
    return data;
};

//------------------------------------------------------------
// ویرایش
export const Update_ObjectOutOfService_Api = async (params) => {
    const { data } = await request.post(
        "/ObjectOutOfServices/Update",
        params
    );
    return data;
};

//------------------------------------------------------------
// حذف
export const Delete_ObjectOutOfService_Api = async (id) => {
    try {
    const { data } = await request.delete(
        `/ObjectOutOfServices/Delete?id=`+ id,
    );
    
    return data;
    } catch (error) {
  console.log('خطای کامل:', error);
  console.log('پیام خطا:', error.message);
  console.log('کد وضعیت:', error.response?.status);
  console.log('داده خطا:', error.response?.data);
  console.log('پیکربندی:', error.config);
}
};